module.exports = __webpack_public_path__ + "img/20.2abac5b9.png";